import React from "react";
import { SITE_CONFIG } from "../data/config";
import { MessageCircle, ExternalLink, ShieldAlert } from "lucide-react";

const Footer = () => {
  const waLink = `https://wa.me/${SITE_CONFIG.whatsappNumber}`;

  return (
    <footer className="mt-10 border-t border-white/5 bg-[#060B1E]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10">
        <div className="flex items-start gap-3 bg-orange-500/10 border border-orange-500/30 rounded-2xl p-4 mb-8">
          <ShieldAlert className="w-5 h-5 text-orange-300 mt-0.5 flex-shrink-0" />
          <p className="text-orange-100/90 text-sm leading-relaxed">
            {SITE_CONFIG.disclaimerText}
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <img
              src={SITE_CONFIG.logoUrl}
              alt="Rush"
              className="rush-logo h-14 w-auto object-contain"
            />
            <div>
              <div className="text-white font-bold">{SITE_CONFIG.storeName}</div>
              <div className="text-white/50 text-sm">حاسبة عجلات CP الاحترافية</div>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <a
              href={waLink}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-emerald-500 hover:bg-emerald-600 text-white text-sm font-semibold transition-colors"
            >
              <MessageCircle className="w-4 h-4" />
              واتساب
            </a>
            <a
              href={SITE_CONFIG.storeUrl}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-white/5 hover:bg-white/10 text-white border border-white/10 text-sm font-semibold transition-colors"
            >
              <ExternalLink className="w-4 h-4" />
              العودة للمتجر
            </a>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-white/5 text-center text-white/40 text-xs">
          © {new Date().getFullYear()} {SITE_CONFIG.storeName}. جميع الحقوق محفوظة.
          <span className="mx-2 text-white/20">·</span>
          <a
            href="/admin"
            data-testid="admin-entry-link"
            className="text-white/40 hover:text-[#C9A96A] transition-colors underline decoration-white/20 underline-offset-4"
          >
            دخول الإدارة
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
